import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Tag = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Tag' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M11.7058543,22.2941457 C11.3160217,22.6839783 10.6897542,22.6897542 10.2968194,22.2968194 L1.70318058,13.7031806 C1.31482467,13.3148247 1.32097101,12.679029 1.70585426,12.2941457 L13,1 L23,1 L23,11 L11.7058543,22.2941457 Z M6,12 L12,18 M9,9 L15,15 M17,6 C17,5.4475 17.4475,5 18,5 C18.5525,5 19,5.4475 19,6 C19,6.5525 18.5525,7 18,7 C17.4475,7 17,6.5525 17,6' />
  </StyledIcon>
);
